var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-background-blurr",style:(`width: calc(${_vm.project_length + 1} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom)); `)},[_vm._t("default",null,{"statistics":_vm.statistics,"current_takt_index":_vm.current_takt_index,"current_day_index":_vm.current_day_index})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }